
<script>
  import RbLoading from '../../_core/RbvLoading.vue';
  import rbEventsMixin from '../../_mixins/RbEventsMixin.vue';

  export default {
    name: 'SupplierMixin',
    components: { RbLoading },
    mixins: [rbEventsMixin],
    props: {
      supplier: {
        type: Object,
        required: true,
      },
      filters: {
        type: Object,
        default: ()=> ({})
      },
      sorter: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      formattedDistance () { return `${Number(this.supplier.distanceMi).toFixed(2)}mi`},
      isSelected() { return this.supplier.bidState !== 'NA' },
    },
    methods: {
      handleSupplierCheckboxClicked(supplier){
        if (supplier.bidState === 'ADDED') {
          this.removeFromBidManager(supplier)
        } else if (supplier.bidState === 'NA') {
          this.addToBidManager(supplier)
        }
      },
      removeFromBidManager(supplier) {
        this.$rbEmit({
          name: 'onRemoveFromBidManager',
          supplier
        });
      },
      addToBidManager(supplier) {
        this.$rbEmit({
          name: 'onAddToBidManager',
          supplier
        });
      }
    }
  }
</script>
